import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "module-settings-v2",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "moduleSettingsV2" */ "./components"),
      import(
        /* webpackChunkName: "moduleSettingsV2" */ "Administrator/routes/SchoolSettings/routes/ModuleSettingsV2/modules/ModuleSettingsV2Module"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "moduleSettingsV2",
          reducer,
        });
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
});
